import {Component, h, Prop} from '@stencil/core';
import {endpoint_portal} from "../../../utils/utils";

@Component({
    tag: 'ike-page-loader',
    styleUrl: 'ike-page-loader.scss',
    shadow: false,
})
export class IkePageLoader {

    @Prop() color: string = '#FF3E60';

    render() {
        return (
            <div class="loader">
                <svg class="loader__img colorizeIcon" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <title>ticket</title>
                    <g id="ticket" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path fill-rule="evenodd" clip-rule="evenodd" fill={this.color}
                              d="M1.04325e-06 14.84C-0.000128712 14.2063 0.445777 13.6601 1.06666 13.5333C1.99879 13.344 2.66867 12.5245 2.66867 11.5733C2.66867 10.6222 1.99879 9.8026 1.06666 9.6133C0.445777 9.4866 -0.000129173 8.9404 4.7208e-07 8.3067L0 2.90666C-9.656e-08 1.80209 0.89543 0.906662 2 0.906662H30C30.5304 0.906662 31.0391 1.11737 31.4142 1.49245C31.7893 1.86752 32 2.37622 32 2.90666V8.3067C32.0001 8.9403 31.5542 9.4866 30.9333 9.6133C30.0012 9.8026 29.3313 10.6222 29.3313 11.5733C29.3313 12.5245 30.0012 13.344 30.9333 13.5333C31.5542 13.6601 32.0001 14.2063 32 14.84V20.24C32 21.3446 31.1046 22.24 30 22.24H2C0.895432 22.24 1.61189e-06 21.3446 1.51533e-06 20.24L1.04325e-06 14.84ZM24.7063 4.23999C24.7063 3.6877 24.2586 3.23999 23.7063 3.23999C23.154 3.23999 22.7063 3.6877 22.7063 4.23999C22.7063 4.79228 23.154 5.23999 23.7063 5.23999C24.2586 5.23999 24.7063 4.79228 24.7063 4.23999ZM23.7063 8.1293C24.2586 8.1293 24.7063 8.577 24.7063 9.1293C24.7063 9.6816 24.2586 10.1293 23.7063 10.1293C23.154 10.1293 22.7063 9.6816 22.7063 9.1293C22.7063 8.577 23.154 8.1293 23.7063 8.1293ZM24.7063 14.0173C24.7063 13.465 24.2586 13.0173 23.7063 13.0173C23.154 13.0173 22.7063 13.465 22.7063 14.0173C22.7063 14.5696 23.154 15.0173 23.7063 15.0173C24.2586 15.0173 24.7063 14.5696 24.7063 14.0173ZM23.7063 17.9066C24.2586 17.9066 24.7063 18.3543 24.7063 18.9066C24.7063 19.4589 24.2586 19.9066 23.7063 19.9066C23.154 19.9066 22.7063 19.4589 22.7063 18.9066C22.7063 18.3543 23.154 17.9066 23.7063 17.9066ZM10.9138 6.4828H8V16.7511H10.9138V14.8179L11.9855 13.7673L13.4914 16.7511H16.7064L13.8836 11.9181L16.5523 9.3125H13.0431L10.9138 11.778V6.4828Z"/>
                    </g>
                </svg>
                <div class="progress-bar">
                    <div class="progress-bar__bg">
                        <div class="progress-bar__loader"/>
                    </div>
                </div>
                <div>
                    <div class="layout-padding">
                        <div class="flex justify-flex-end">
                            <div class="flex">
                                <p class="text-4">powered by <a class="infomaniak" target={'_blank'} href={`${endpoint_portal}`}>infomaniak</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
